/* This file will have the bread crumb details pertaining to each page of the application */
export const STEPINDICATORS = {
    'stepobjArr': [
        { label: 'Select an account', stepNumber: 1, path: 'billing', isVisited: false },
        { label: 'Provide details', stepNumber: 2, path: 'serviceConfiguration', isVisited: false },
        { label: 'Review order', stepNumber: 3, path: 'reviewOrder', isVisited: false },
        { label: 'Confirm', stepNumber: 4, path: 'confirmOrder', isVisited: false }],

    'manageUsers': [
        { label: 'Select an action', stepNumber: 1, path: 'action', isVisited: false },
        { label: 'Select products', stepNumber: 2, path: 'products', isVisited: false },
        { label: 'Select users', stepNumber: 3, path: 'users', isVisited: false },
        { label: 'Review changes', stepNumber: 4, path: 'review', isVisited: false }],
    'bulkUsers': [
        { label: 'Select an action', stepNumber: 1, path: 'bulk-action', isVisited: false },
        { label: 'Upload', stepNumber: 2, path: 'bulk-upload', isVisited: false },
        { label: 'Review', stepNumber: 3, path: 'bulk-review', isVisited: false },
        { label: 'Confirm', stepNumber: 4, path: 'bulk-confirm', isVisited: false }],
    'signUp': [
        { label: 'Accounts', stepNumber: 1, path: 'accounts', isVisited: true },
        { label: 'Settings', stepNumber: 2, path: 'settings', isVisited: false },
        { label: 'Applications', stepNumber: 3, path: 'applications', isVisited: false },
        { label: 'Enrollment date', stepNumber: 4, path: 'startdate', isVisited: false },
        { label: 'Review', stepNumber: 5, path: 'review', isVisited: false },
        { label: 'Confirm', stepNumber: 6, path: 'confirm', isVisited: false }],
    'sendSMS': [
        { label: 'Message', stepNumber: 1, path: 'message', isVisited: false },
        { label: 'Accounts', stepNumber: 2, path: 'account', isVisited: false },
        { label: 'Review', stepNumber: 3, path: 'review', isVisited: false }],
    'groupingDevices': [
        { label: 'Select Devices', stepNumber: 1, path: 'selectDevices', isVisited: false },
        { label: 'Select Group', stepNumber: 2, path: 'selectGroup', isVisited: false },
        { label: 'Review', stepNumber: 3, path: 'review', isVisited: false }],
    'transaction': [
        { label: 'Report type', stepNumber: 1, path: 'reportType', isVisited: true },
        { label: 'Date range', stepNumber: 2, path: 'dateRange', isVisited: false },
        { label: 'Review', stepNumber: 3, path: 'review', isVisited: false },
        { label: 'Confirmation', stepNumber: 4, path: 'confirmation', isVisited: false }],
    'signUpOem': [
        { label: 'Accounts', stepNumber: 1, path: 'accounts', isVisited: true },
        { label: 'Settings', stepNumber: 2, path: 'settings', isVisited: false },
        { label: 'Enrollment date', stepNumber: 3, path: 'startdate', isVisited: false },
        { label: 'Review', stepNumber: 4, path: 'review', isVisited: false },
        { label: 'Confirmation', stepNumber: 5, path: 'confirm', isVisited: false }],
    'signUpAll': [
        { label: 'Enrollment Options', stepNumber: 1, path: 'enrollmentoptions', isVisited: true },
        { label: 'Review', stepNumber: 2, path: 'review', isVisited: false },
        { label: 'Confirm', stepNumber: 3, path: 'confirm', isVisited: false }],
    'efotaEnrollment': [
        { label: 'Enrollment Options', stepNumber: 1, path: 'selectaccounts', isVisited: true },
        { label: 'Review', stepNumber: 2, path: 'review', isVisited: false },
        { label: 'Confirm', stepNumber: 3, path: 'confirm', isVisited: false }],
        'fiveGEnrollment': [
            { label: 'Request Info', stepNumber: 1, path: 'selectaccounts', isVisited: true },
            { label: 'Review', stepNumber: 2, path: 'review', isVisited: false },
            { label: 'Confirm', stepNumber: 3, path: 'confirm', isVisited: false }]

};
